export const initExternalLinks = () => {
    let links = document.querySelectorAll('a[href^=http]');

    links.forEach(function (link) {
        if (! link.href.match(RegExp('https?\://(www\.|)' + window.location.hostname))) {
            link.setAttribute('target', '_blank');
        }
    });
};